var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeSlashedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63299 1.2477C1.4759 1.08532 1.21691 1.08102 1.05453 1.23811C0.89214 1.3952 0.887845 1.65419 1.04493 1.81657L4.44946 5.33591C2.35033 7.01915 1.54476 9.44738 1.52325 9.51288L1.52287 9.51363C1.44412 9.76113 1.57912 10.0236 1.82662 10.1024C2.07412 10.1811 2.33662 10.0461 2.41537 9.79863C2.46004 9.65967 3.18619 7.46639 5.09044 5.99851L6.69623 7.65845C6.66825 7.68458 6.64067 7.71124 6.61351 7.7384C5.98058 8.37133 5.625 9.22978 5.625 10.1249C5.625 11.02 5.98058 11.8784 6.61351 12.5114C7.24645 13.1443 8.10489 13.4999 9 13.4999C9.8951 13.4999 10.7535 13.1443 11.3865 12.5114C11.3872 12.5106 11.388 12.5099 11.3887 12.5092L14.6978 15.9299C14.8549 16.0923 15.1139 16.0966 15.2763 15.9395C15.4387 15.7824 15.443 15.5234 15.2859 15.361L11.8965 11.8573C11.8964 11.8573 11.8965 11.8573 11.8965 11.8573L7.36461 7.17257C7.3646 7.17257 7.36461 7.17256 7.36461 7.17257L5.7795 5.53405C5.77949 5.53405 5.77951 5.53404 5.7795 5.53405L5.1219 4.85423C5.1219 4.85424 5.12191 4.85423 5.1219 4.85423L1.63299 1.2477Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86244 4.44299L6.55001 5.15374C7.25625 4.86487 8.06911 4.68738 9.00037 4.68738C13.8941 4.68738 15.5175 9.58863 15.585 9.79863C15.6229 9.91688 15.7062 10.0153 15.8166 10.0722C15.927 10.1291 16.0554 10.14 16.1737 10.1024C16.4175 10.0236 16.5562 9.76113 16.4775 9.51363L16.477 9.51202C16.4381 9.39542 14.557 3.74988 8.99962 3.74988C7.78454 3.74988 6.7452 4.01987 5.86244 4.44299Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2476 11.0435L8.18959 6.84861C8.45258 6.78355 8.72456 6.74988 9 6.74988C9.8951 6.74988 10.7535 7.10546 11.3865 7.7384C12.0194 8.37133 12.375 9.22978 12.375 10.1249C12.375 10.4383 12.3314 10.7472 12.2476 11.0435Z",
    fill: "#F6F6F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlashedIcon);
export default __webpack_public_path__ + "static/media/eyeSlashedIcon.f1342cb1d9e6042c6d9a9cdb96af7c53.svg";
export { ForwardRef as ReactComponent };